import React from 'react';

import Autocomplete from "@mui/material/Autocomplete";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from "@mui/material/TextField";


function WidgetInputTextList({ state, setState, id, text, readOnly = false, value = [] }) {
  React.useEffect(() => {
    setState({
      id: id,
      value: value,
      error: false,
      errorMessage: null,
    });
  }, []);

  const handleChange = (e, v) => {
    setState((s) => ({ ...s, value: v, error: false }));
  };


  return (
    <>
      {state !== null &&
        <FormControl error={state.error} className='w-full'>
          <Autocomplete
            className='shadow-md shadow-gray-300'
            multiple
            freeSolo
            id={state.id}
            options={[]}
            getOptionLabel={(option) => option}
            readOnly={readOnly}

            value={state.value}
            onChange={handleChange}

            renderInput={(v) => (<TextField  {...v} error={state.error} variant='outlined' label={text} />)}
          />
          <FormHelperText>
            (Appuiez sur "Entrer" pour ajouter)
            <br />
            {state.error && state.errorMessage}
          </FormHelperText>
        </FormControl>
      }
    </>
  );
}

export default React.memo(WidgetInputTextList);